import { Component, Input } from '@angular/core';
import { BaseModalComponent } from '@card-software/library';
import { ProductionCardStatus } from '@app/models/production/production-card';

@Component({
  selector: 'app-reassignment-modal',
  templateUrl: './reassignment-modal.component.html',
  styleUrl: './reassignment-modal.component.scss',
})
export class ReassignmentModalComponent extends BaseModalComponent<boolean | null> {
  @Input() productionCardNumber = '';
  @Input() targetStatus: ProductionCardStatus.Closed | ProductionCardStatus.Reassignment = ProductionCardStatus.Reassignment;

  get isEnablingReassignment(): boolean {
    return this.targetStatus === ProductionCardStatus.Reassignment;
  }

  onConfirm(): void {
    this.close({ action: 'save', data: true });
  }

  onCancel(): void {
    this.close({ action: 'close', data: null });
  }
}
